var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 video-container"},[_c('iframe',{attrs:{"width":"560","height":"315","src":("https://www.youtube.com/embed/" + _vm.id),"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4daf0ec1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/VideoPlayer.vue
// module id = null
// module chunks = 